export default __webpack_public_path__ + "static/media/gamblingIIE.2496c943.JPG";